import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchHoaMembers } from "../../../src/services/api/Member";
import { X } from "lucide-react";
import PageHeader from "../Header";

interface HoaMember {
  id: number;
  name_of_association: string;
  icon?: string;
  president_name?: string;
  name_of_sec?: string;
  address?: string;
  email?: string;
  phone?: string;
  website?: string;
}

const MemberPage: React.FC = () => {
  const { slug } = useParams();
  const [members, setMembers] = useState<HoaMember[]>([]);
  const [selectedMember, setSelectedMember] = useState<HoaMember | null>(null);

  useEffect(() => {
    const fetchMembers = async () => {
      const response = await fetchHoaMembers(`hoa-members/${slug}`);

      const fetchedMembers = response?.data?.data?.[0]?.hoa_members || [];

      const sortedMembers = [...fetchedMembers].sort((a, b) =>
        a.name_of_association.localeCompare(b.name_of_association)
      );
      console.log("data", response,response?.data?.data?.[0]?.hoa_members.length, sortedMembers.length);
      debugger;

      setMembers(sortedMembers);
    };
    if (slug) fetchMembers();
  }, [slug]);

  return (
    <div className="max-w-full mx-auto">
      {/* PAGE HEADER */}
      <PageHeader title={slug?.replace(/-/g, " ")} slug={slug} />

      {/* MEMBERS GRID */}
      
        <div
  className={` ${
    members.length < 6
      ? "grid gap-8 py-12 md:px-16 px-5 grid-cols-1 sm:grid-cols-2 md:grid-cols-3"
      : "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 py-12 md:px-16 px-5"
  }`}
>
        {members.map((item) => (
          <div
            key={item.id}
            onClick={() => setSelectedMember(item)}
            className="cursor-pointer bg-white rounded-lg border shadow-sm hover:shadow-lg transition"
            title={item.name_of_association}
          >
              {/* TOOLTIP */}
  <div className="absolute top-3 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-all duration-300 z-20">
    
    <div className="bg-black/90 text-white text-xs px-3 py-2 rounded-lg shadow-lg whitespace-nowrap">
      {item.name_of_association}
    </div>

  </div>
            <div
              className="text-center py-3 font-semibold uppercase text-sm rounded-t-lg bg-gradient-to-r from-blue-900 to-indigo-900 text-white"
            >
              {item.name_of_association}
            </div>

            <div className="flex items-center justify-center h-[130px] p-4">
              {item.icon ? (
                <img src={item.icon} className="w-24 h-24 object-contain" alt={item.name_of_association} />
              ) : (
                <span className="text-gray-400">No Logo</span>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* ================= MODAL ================= */}
{selectedMember && (
  <div
    className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-3 sm:p-5 overflow-y-auto"
    onClick={() => setSelectedMember(null)}
  >
    {/* MODAL */}
    <div
      className="
        relative 
        w-full 
        max-w-5xl 
        bg-white 
        rounded-2xl sm:rounded-3xl 
        shadow-2xl 
        overflow-hidden 
        animate-in fade-in zoom-in-95 duration-300
        my-auto
      "
      onClick={(e) => e.stopPropagation()}
    >
      {/* HEADER */}
      <div className="relative bg-gradient-to-r from-blue-900 via-indigo-900 to-blue-700 px-4 sm:px-6 md:px-8 py-5 sm:py-6">

        {/* CLOSE BUTTON */}
        <button
          onClick={() => setSelectedMember(null)}
          className="
            absolute top-3 right-3 sm:top-4 sm:right-5
            w-9 h-9 sm:w-10 sm:h-10
            rounded-full
            bg-white/20 hover:bg-white/30
            text-white
            flex items-center justify-center
            transition
          "
        >
          <X className="w-5 h-5" />
        </button>

        <h2 className="
          text-lg sm:text-2xl md:text-3xl
          font-bold
          text-white
          uppercase
          tracking-wide
          text-center
          leading-snug
          pr-10
        ">
          {selectedMember.name_of_association}
        </h2>
      </div>

      {/* BODY */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8 p-4 sm:p-6 md:p-8">

        {/* LEFT SIDE */}
        <div className="flex flex-col items-center">

          {/* IMAGE */}
          <div className="
            w-40 h-40
            sm:w-52 sm:h-52
            md:w-60 md:h-60
            rounded-2xl
            overflow-hidden
            border
            shadow-lg
            bg-gray-100
          ">
            {selectedMember.icon ? (
              <img
                src={selectedMember.icon}
                alt={selectedMember.name_of_association}
                className="w-full h-full object-contain"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-gray-400">
                No Image
              </div>
            )}
          </div>
        </div>

        {/* RIGHT CONTENT */}
        <div className="lg:col-span-2">

          <h3 className="
            text-xl sm:text-2xl
            font-bold
            text-gray-800
            mb-5
            border-b
            pb-3
          ">
            Association Details
          </h3>

          <div className="space-y-5">

            {selectedMember.president_name && (
              <div className="flex flex-col sm:flex-row gap-1 sm:gap-3">
                <span className="font-semibold text-gray-700 min-w-[120px] uppercase">
                  President :
                </span>

                <span className="text-gray-600 break-words capitalize">
                  {selectedMember.president_name}
                </span>
              </div>
            )}

            {selectedMember.name_of_sec && (
              <div className="flex flex-col sm:flex-row gap-1 sm:gap-3">
                <span className="font-semibold text-gray-700 min-w-[120px] uppercase">
                  Secretary :
                </span>

                <span className="text-gray-600 break-words capitalize">
                  {selectedMember.name_of_sec}
                </span>
              </div>
            )}

            {selectedMember.email && (
              <div className="flex flex-col sm:flex-row gap-1 sm:gap-3">
                <span className="font-semibold text-gray-700 min-w-[120px] uppercase">
                  Email :
                </span>

                <span className="text-gray-600 break-all">
                  {selectedMember.email}
                </span>
              </div>
            )}

            {selectedMember.address && (
              <div className="flex flex-col sm:flex-row gap-1 sm:gap-3">
                <span className="font-semibold text-gray-700 min-w-[120px] uppercase">
                  Address :
                </span>

                <span className="text-gray-600 break-words">
                  {selectedMember.address}
                </span>
              </div>
            )}

            {selectedMember.phone && (
              <div className="flex flex-col sm:flex-row gap-1 sm:gap-3">
                <span className="font-semibold text-gray-700 min-w-[120px] uppercase">
                  Phone :
                </span>

                <span className="text-gray-600 break-words">
                  {selectedMember.phone}
                </span>
              </div>
            )}

            {selectedMember.website && (
              <div className="flex flex-col sm:flex-row gap-1 sm:gap-3">
                <span className="font-semibold text-gray-700 min-w-[120px] uppercase">
                  Website :
                </span>

                <a
                  href={selectedMember.website}
                  target="_blank"
                  rel="noreferrer"
                  className="text-blue-600 hover:text-blue-800 underline break-all"
                >
                  Visit Website
                </a>
              </div>
            )}

          </div>
        </div>
      </div>

      {/* FOOTER */}
      <div className="flex justify-center px-4 pb-6 sm:pb-8 md:pb-10">
        <button
          onClick={() => setSelectedMember(null)}
          className="
            px-5 sm:px-6
            py-2.5 sm:py-3
            rounded-xl
            bg-blue-700 hover:bg-blue-800
            text-white
            text-sm sm:text-base
            font-semibold
            transition
          "
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default MemberPage;
